
import actionTypes from '../actions/reduxActions/actionTypes';

const notifications = (state = [], { type, payload, error, meta }) => {

    switch (type) {

    case actionTypes.NOTIFICATION_ADD:

        return [
            ...state,
            payload,
        ];

    case actionTypes.NOTIFICATION_REMOVE:
        return state.filter(notification => notification.id !== payload);

    case actionTypes.REMOVE_ALL_NOTIFICATIONS:
        return [];

    default:
        return state;
    }
};

export default notifications;
